import FormControlLabel from "@material-ui/core/FormControlLabel";
import MUICheckbox from "@material-ui/core/Checkbox";
import Typography from "@material-ui/core/Typography";
import React, { FC } from "react";
import { withStyles } from "@material-ui/core/styles";

import classes from "./CustomSlideCheckBoxOption.module.scss";

type CustomSlideCheckBoxOptionProps = {
  label: string;
  description: string;
  icon: React.ReactNode;
  checked: boolean;
  name: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const Checkbox = withStyles({
  root: {
    "&$checked": {
      color: "#FF7A59",
    },
  },
  checked: {},
})((props: any) => <MUICheckbox color="default" {...props} />);

const CustomSlideCheckBoxOption: FC<CustomSlideCheckBoxOptionProps> = ({
  label,
  description,
  icon,
  checked,
  name,
  handleChange,
}) => {
  return (
    <div className={classes.container}>
      <div className={classes.iconWrapper}>{icon}</div>
      <FormControlLabel
        control={<Checkbox checked={checked} name={name} onChange={handleChange} className={classes.checkbox} />}
        label={label}
      />
      <Typography>{description}</Typography>
    </div>
  );
};

export default CustomSlideCheckBoxOption;
